import type { FaireProductEntity } from "../../entity_types/product";

export const p_7rbjwthgzx: FaireProductEntity = {
  token: "p_7rbjwthgzx",
  type: "product",
  name: "Cute Pig Sensory Fidget Stress Toy",
  brandToken: "b_fau7y3uv8k",
  brandName: "MIAS SHOP",
  imageUrl:
    "https://cdn.faire.com/fastly/941cbc563d7f8181b1aa637ba94371b0bebbf2656995e7d9eaa1d75365c22e3a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c3a4fa16ccc1e57e12aab6e98cb0117109637a7b0f96c404a6c7694655c80e93.jpeg",
    "https://cdn.faire.com/fastly/6503f30289bb291e399ff7336bbbd4c98b1c6362d00193160e3e04288d0e81fc.jpeg",
    "https://cdn.faire.com/fastly/11c22aa8a95464368eaf6b3dcd7b5d632eda77a72f625d9a37641fea213963e6.jpeg",
    "https://cdn.faire.com/fastly/1ca57b4dc3c9eef39745550eac8d6ffe4ae4e2ce79206bb9d610906630d936cc.jpeg",
  ],
  priceDollars: 3.78,
  description:
    "Material: TPR\nSize :8 cm .\nWeight: 100G\nFeature:\n1. When you waste time due to stress or boredom, especially in the case of boredom, squeeze and pull over and over again.\n2. Some people need to squeeze things when thinking and brainstorming, so this gadget is great for them.\n3. When you are in a bad mood, pick up the squeeze ball and squeeze it again and again. It feels very cool. You can vent all your sullenness on this little toy.\n4. If you are wronged,stressed, Unhappy, then use the ball to vent it, pinch it as you like.Let the uncomfortable emotions disappear every second. It is interesting to pinch the ball, and come out a beautiful and fun bunch of grapes.\n",
  tags: [],
  msrpDollars: 7.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:29.177Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
